import { Routes } from '@angular/router';
import { CanActivateguard } from '../../service/auth-service.service';


export const FinanceRoute : Routes = [

    {path:'company-code-requester',loadComponent:()=>import('../Financial Master Data/company-code-requester/company-code-requester.component').then(m=>m.CompanyCodeRequesterComponent)},
      {path:'controlling-area',loadComponent:()=>import('../Financial Master Data/controlling-area/controlling-area.component').then(m=>m.ControllingAreaComponent)},
      {path:'profit-center',loadComponent:()=>import('../Financial Master Data/profit-center/profit-center.component').then(m=>m.ProfitCenterComponent)},
      {path:'general-ledger-account',loadComponent:()=>import('../Financial Master Data/general-ledger-account/general-ledger-account.component').then(m=>m.GeneralLedgerAccountComponent)},
      {path:'cost-center',loadComponent:()=>import('../Financial Master Data/cost-center/cost-center.component').then(m=>m.CostCenterComponent)}

]
